import clsx from 'clsx';
import { Section, SectionContent } from '../../../../../components/Section';
import { SettingRow } from '../../../../Manage/Operator/Settings/SettingRow';
import { Divider } from '../../../../../components/Divider';
import { useCreateOperator } from '../../../../../contexts/CreateOperatorContext';
import { Input } from '../../../../../components/Input';
import { CollapsableContent } from '../../../../../components/CollapsableContent/CollapsableContent';
import { SettingTag } from '../../SettingTag';
import { ChangeEvent } from 'react';

export const AppKeys = () => {
  const { operator, updateOperator } = useCreateOperator();
  const classes = useStyles();

  if (operator.mediaRoomSettings === undefined) return null;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    updateOperator(
      'mediaRoomSettings',
      Object.assign(operator.mediaRoomSettings!, {
        [event.target.name]: event.target.value,
      })
    );
  };

  const defaultInputProps: any = {
    fullWidth: true,
    onChange: handleChange,
    variant: 'contained',
  };

  return (
    <CollapsableContent
      defaultExpanded
      icon={<SettingTag name="Mediaroom" color="violet" size="sm" />}
      header={<p>AppKey Mapping</p>}
      padding="sm"
    >
      <Section fullWidth>
        <SectionContent padding="none">
          <SettingRow
            icon={<p className={clsx(classes.tag, 'bg-red-500')}>A</p>}
            level="sub"
            title="AppKey URL 1"
          >
            <Input
              name="appKeyUrl1"
              value={operator.mediaRoomSettings?.appKeyUrl1 ?? ''}
              {...defaultInputProps}
            />
          </SettingRow>
          <Divider />
          <SettingRow
            icon={<p className={clsx(classes.tag, 'bg-green-500')}>B</p>}
            level="sub"
            title="AppKey URL 2"
          >
            <Input
              name="appKeyUrl2"
              value={operator.mediaRoomSettings?.appKeyUrl2 ?? ''}
              {...defaultInputProps}
            />
          </SettingRow>
          <Divider />
          <SettingRow
            icon={<p className={clsx(classes.tag, 'bg-yellow-500')}>C</p>}
            level="sub"
            title="AppKey URL 3"
          >
            <Input
              name="appKeyUrl3"
              value={operator.mediaRoomSettings?.appKeyUrl3 ?? ''}
              {...defaultInputProps}
            />
          </SettingRow>
          <Divider />
          <SettingRow
            icon={<p className={clsx(classes.tag, 'bg-blue-500')}>D</p>}
            level="sub"
            title="AppKey URL 4"
          >
            <Input
              name="appKeyUrl4"
              value={operator.mediaRoomSettings?.appKeyUrl4 ?? ''}
              {...defaultInputProps}
            />
          </SettingRow>
        </SectionContent>
      </Section>
    </CollapsableContent>
  );
};

const useStyles = () => ({
  tag: 'px-4 rounded-full text-white',
});
